import { render } from "./ProfileTemplateForm.vue?vue&type=template&id=2b059ae6"
import script from "./ProfileTemplateForm.vue?vue&type=script&lang=js"
export * from "./ProfileTemplateForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__